module.exports = __webpack_public_path__ + "img/__icon_CYSTERNA_CHEMIA.11c2b351.svg";